import { DefaultError, useMutation } from "@tanstack/react-query";
import { sendPasswordResetEmail } from "../api";

type ResetPasswordParams = {
  email: string;
};

const useResetPasswordMutation = (onSuccess: () => void) => {
  return useMutation<void, DefaultError, ResetPasswordParams>({
    mutationFn: async ({ email }) => {
      await sendPasswordResetEmail(email);
    },
    onSuccess: () => {
      onSuccess();
    },
    onError: (e) => {
      throw new Error(e.message);
    },
  });
};

export default useResetPasswordMutation;
